export default "__VITE_ASSET__2a062cc8__"